import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PostmessageService {

  private sameOrigin = '*';

  constructor() { }

  sendPostMessage(message: any, partner?: boolean) {
    if (!partner) {
      message = {
        ...message,
        noPartner: true
      };
    }
    window.parent.postMessage( message, this.sameOrigin);
  }
}
